import React, {useState} from 'react';
import {Link, useHistory, useParams} from 'react-router-dom';
import ReactSelect from 'react-select';

import {DataTable} from '../components/DataTable';
import {LoadingIndicator} from '../components/LoadingIndicator';
import {SortableColumnState} from '../types';
import {useInbox} from '../_hooks/useInbox';

type InboxPageProps = {};

export const Inbox: React.FunctionComponent<InboxPageProps> = ({}) => {
    const history = useHistory();
    const {workflowId} = useParams();
    const {
        inbox,
        isLoading,
        inboxLoadingErrorMessage,
        availableWorkflows,
        filterFormState,
        setFilterFormState
    } = useInbox(workflowId);

    const [sort, setSort] = useState<SortableColumnState>(null);

    const sortEntries = (first: any, second: any) => {
        if (!sort) return 0;
        if (!first.hasOwnProperty(sort?.column) || !second.hasOwnProperty(sort?.column)) return 0;

        return (sort.direction === 'asc') ?
            first[sort.column].localeCompare(second[sort.column])
            :
            second[sort.column].localeCompare(first[sort.column]);
    };

    return (
        <div>
            <h1 className={'abb-header'}>Inbox</h1>

            <p>This page lists all workflows <strong>assigned</strong> to you. For a list of workflows <strong>initiated</strong> by you, go to <Link to="/my-requests">My Requests</Link></p>

            {inboxLoadingErrorMessage && <p className="alert alert-danger">{inboxLoadingErrorMessage}</p>}
            {isLoading && <LoadingIndicator/>}

            {availableWorkflows?.length > 1 &&
                <div className="row">
                    <div className="col-12 col-sm-6 col-md-4 mb-2">
                        <ReactSelect
                            defaultValue={filterFormState?.workflow || null}
                            options={availableWorkflows}
                            isClearable={true}
                            placeholder={'Filter by Workflow'}
                            value={filterFormState?.workflow || null}
                            onChange={(option, action) => {
                                setFilterFormState(state => ({
                                    ...state,
                                    workflow: option
                                }));
                            }}
                        />
                    </div>
                </div>
            }

            {inbox.entries &&
                <DataTable
                    id="inbox-table"
                    striped={true}
                    classNames="table-borderless"
                    headings={inbox.columns}
                    sortable={true}
                    setSort={setSort}
                    sortState={sort}
                    rows={inbox.entries.sort(sortEntries)}
                    onRowClick={(row: any) => {
                        history.push('/entry/' + row.id);
                    }}
                />
            }
        </div>
    );
};

